function formatCents(cents: number): string {
  if (!Number.isFinite(cents)) return '—';
  return `${(cents / 100).toFixed(2).replace('.', ',')} €`;
}

function formatHoursLabel(raw: string): string {
  if (raw === '') return '—';
  const n = Number(raw);
  if (!Number.isFinite(n)) return raw;
  return `${n.toFixed(2).replace(/\.?0+$/, '').replace('.', ',')} h`;
}

export function formatHistoryReason(
  reason: string | null | undefined,
  t: (key: string, opts?: Record<string, string | number>) => string,
): string | null {
  if (!reason) return null;

  const laborHours = /^labor_hours:([^:]*):([^:]*):(.*)$/.exec(reason);
  if (laborHours) {
    const from = formatHoursLabel(laborHours[1] ?? '');
    const to = formatHoursLabel(laborHours[2] ?? '');
    let step = laborHours[3] ?? '';
    try {
      step = decodeURIComponent(step);
    } catch {
      // keep the raw encoded description
    }
    return t('statusHistory.laborHoursChanged', { step, from, to });
  }

  // vehicle:<old reg>:<new reg> (#3285); the old reg is empty for a deleted car.
  const vehicle = /^vehicle:([^:]*):(.*)$/.exec(reason);
  if (vehicle) {
    return t('statusHistory.vehicleChanged', { from: vehicle[1] || '—', to: vehicle[2] ?? '' });
  }

  const laborRate = /^labor_rate_cents:(.*):(.*)$/.exec(reason);
  if (!laborRate) return reason;
  const fromRaw = laborRate[1] ?? '';
  const toRaw = laborRate[2] ?? '';
  const from = fromRaw === '' ? '—' : formatCents(Number(fromRaw));
  const to = formatCents(Number(toRaw));
  return t('statusHistory.laborRateChanged', { from, to });
}
